import React from 'react';
import { useStoreon } from 'storeon/react';
import { Breadcrumbs, SeoText } from 'common/components';
import { Layout } from 'fronton-react';
import { usePageViewEvent } from 'common/hooks';
import { State } from 'store/types';
import {
  MODEL_JSON_STORE_NAME,
  selectBreadcrumbs,
  selectCurrentUrl,
  selectRegionId,
  selectSeoProperties,
} from 'modules/model-json';
import { LANDINGS_STORE_NAME } from 'modules/landings-info';
import { SERVICE_CATEGORIES_STORE_NAME } from 'modules/service-categories';
import { COOKIES_STORE_NAME, selectPageViewData } from 'modules/cookies';
import { SERVICES_MAIN_PATH } from './services-main-constants';
import {
  ServicesHeaderSection,
  ServicesPopularSection,
  ServicesCatalogSection,
  ServicesInstoreSection,
} from './components';

/**
 * Вью страницы "Услуги разводящая"
 */
export const ServicesMain = () => {
  const { modelJson, cookies } = useStoreon<State>(MODEL_JSON_STORE_NAME, COOKIES_STORE_NAME);
  const { landings } = useStoreon<State>(LANDINGS_STORE_NAME);
  const { serviceCategories } = useStoreon<State>(SERVICE_CATEGORIES_STORE_NAME);

  const seoProperties = React.useMemo(() => selectSeoProperties(modelJson), [modelJson]);
  const breadcrumbs = React.useMemo(() => selectBreadcrumbs(modelJson), [modelJson]);
  const currentUrl = React.useMemo(() => selectCurrentUrl(modelJson), [modelJson]);
  const pageViewData = React.useMemo(() => selectPageViewData(cookies), [cookies]);
  const regionId = selectRegionId(modelJson);

  const { landingsList } = landings;
  const { serviceCategoriesList } = serviceCategories;

  usePageViewEvent(currentUrl, 'ServicePage', pageViewData);

  return (
    <Layout>
      <Breadcrumbs breadcrumbs={breadcrumbs} currentPage={SERVICES_MAIN_PATH} showCurrentPage={false} />
      <ServicesHeaderSection />
      <ServicesPopularSection landingsList={landingsList} serviceCategoriesList={serviceCategoriesList} regionId={regionId} />
      <ServicesCatalogSection landingsList={landingsList} serviceCategoriesList={serviceCategoriesList} />
      <ServicesInstoreSection serviceCategoriesList={serviceCategoriesList} regionId={regionId} />
      <SeoText seoProperties={seoProperties} />
    </Layout>
  );
};
